import React from 'react'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import remarkGfm from 'remark-gfm'
import AppH5JSSDK from '@i61/app-h5-jssdk'
import axios from 'axios'
import envConfig from './env.config'

import './style.less'

const DEFAULT_PAGE_TITLE = '画啦啦美术课堂未成年人隐私保护政策'

export default class App extends React.Component {
  constructor() {
    super()
    AppH5JSSDK.updatePageTitle(DEFAULT_PAGE_TITLE)

    this.state = {
      markdownText: `<div class="loading">内容加载中...</div>`,
      metadata: {},
    }
  }

  async componentDidMount() {
    try {
      const protocolUrlKey = 'hll_children_privacy_protocol_url'
      const localHllChildrenPrivacyProtocolUrl = window.localStorage.getItem(protocolUrlKey)

      // 如果本地有缓存的链接，先去请求协议内容
      // 得到kv链接之后与本地缓存的链接做对比，如果链接不同，重新请求协议内容
      let [urls, markdownText] = await Promise.all([
        this.getKvConfig(),
        this.getMarkdownText(localHllChildrenPrivacyProtocolUrl),
      ])

      const hllChildrenPrivacyProtocolUrl = urls.hll_children_privacy_protocol_url

      if (!hllChildrenPrivacyProtocolUrl) {
        throw new Error('协议链接不存在')
      }

      // 如果本地缓存的链接与kv的链接不同，需要重新请求协议内容
      if (
        hllChildrenPrivacyProtocolUrl &&
        hllChildrenPrivacyProtocolUrl !== localHllChildrenPrivacyProtocolUrl
      )
      {
        markdownText = await this.getMarkdownText(hllChildrenPrivacyProtocolUrl)
      }

      // 解析metadata数据
      const metadata = this.extractMetadata(markdownText)

      const metadataRegex = /^---metadata\s*\n([\s\S]*?)\n---\s*\n/
      this.setState({
        metadata,
        markdownText: markdownText.replace(metadataRegex, ''),
      })

      // 更新页面标题
      if (metadata.title && metadata.title !== DEFAULT_PAGE_TITLE) {
        AppH5JSSDK.updatePageTitle(metadata.title)
      }
    } catch (err) {
      console.log('err', err)
      console.error('加载内容失败', err?.message || err)
      this.setState({
        markdownText: `<div class="loading">内容加载失败</div>`,
      })
    }
  }

  /**
   * 获取kv协议链接
   */
  async getKvConfig() {
    try {
      const res = await axios.post(`${envConfig.keyValueHost}/api/keyValue`, {
        keys: ['h5.protocol.urls']
      }, {
        withCredentials: false,
      })
      if (res?.data?.code !== 0) {
        return Promise.reject(res?.data?.message || '获取kv协议链接失败')
      }
      return res?.data?.data?.h5?.protocol?.urls || {}
    } catch (err) {
      console.error('请求kv协议链接失败', err?.message || err)
      return Promise.reject('请求kv协议链接失败')
    }
  }

  /**
   * 获取md文件内容
   */
  async getMarkdownText(url) {
    if (!url) {
      return null
    }

    try {
      const res = await axios.get(url)
      return res.data
    } catch (err) {
      console.error('请求md文件内容失败', err?.message || err)
      return Promise.reject('请求md文件内容失败')
    }
  }

  /**
   * 提取md文件中的metadata
   */
  extractMetadata(markdownText) {
    if (!markdownText) {
      return {}
    }

    // 匹配元数据块的正则表达式
    const metadataRegex = /^---metadata\s*\n([\s\S]*?)\n---\s*\n/
    const match = markdownText.match(metadataRegex)

    if (!match) {
      return {}
    }

    const metadataBlock = match[1]
    const metadata = {}

    // 逐行解析元数据
    metadataBlock.split('\n').forEach(line => {
      // 匹配键值对
      const keyValueMatch = line.match(/^\s*([^:]+):\s*(.*?)\s*$/)

      if (keyValueMatch) {
        const key = keyValueMatch[1].trim()
        let value = keyValueMatch[2].trim()

        // 去除值周围的引号
        if ((value.startsWith("'") && value.endsWith("'")) ||
            (value.startsWith('"') && value.endsWith('"'))) {
            value = value.substring(1, value.length - 1)
        }

        metadata[key] = value
      }
    })

    return metadata
  }

  render() {
    const { markdownText, metadata } = this.state

    const handleStyle = new Function(`return ${metadata.style || '{}'}`)
    const _style = handleStyle()

    return (
      <div className='children-privacy-agreement' style={{..._style}}>
        <ReactMarkdown rehypePlugins={[rehypeRaw, remarkGfm]}>{markdownText}</ReactMarkdown>
      </div>
    )
  }
}
